<template>
  <v-row no-gutters id="menu-main">
    <v-col @click="routerMethod('/')" class="brand" style="padding:0px;" md="auto">
      <transition name="fade">
        <div v-if="scrollPos > 130 || $route.name != 'Home'">
          <img alt="logo" class="brand-img pa-1" :src="require('@/assets/img/logo.svg')" />
        </div>
      </transition>
    </v-col>
    <v-col md="auto" class="flex-grow-1"></v-col>
    <v-col md="auto" v-if="$vuetify.breakpoint.mdAndUp" class="my-toolbaritems" justify="end">
      <div class="menu-main">
        <v-btn @click="gotoapp()" text class="my-vbtn">
          <span v-bind:class="active === 'poll' ? 'active':''">Go to App</span>
        </v-btn>
        <v-btn @click="routerMethod('features')" text class="my-vbtn">
          <span v-bind:class="active === 'features' ? 'active':''">Features</span>
        </v-btn>
        <v-btn @click="routerMethod('about')" text class="my-vbtn">
          <span v-bind:class="active === 'about' ? 'active':''">About us</span>
        </v-btn>
        <v-btn @click="routerMethod('contact')" text class="my-vbtn">
          <span v-bind:class="active === 'contact' ? 'active':''">Contact</span>
        </v-btn>
        <v-btn v-if="!loggedIn" @click="routerMethod('/register')" text class="my-vbtn">
          <span v-bind:class="active === '/register' ? 'active':''">Register</span>
        </v-btn>
        <v-btn v-if="!loggedIn" @click="routerMethod('/login')" text class="my-vbtn">
          <span v-bind:class="active === '/login' ? 'active':''">Login</span>
        </v-btn>

        <v-menu
          v-if="loggedIn"
          transition="scale-transition"
          open-on-hover
          close-on-click
          close-on-content-click
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text class="my-vbtn">
              <v-icon>keyboard_arrow_down</v-icon>

              <Avatar
                v-if="avatar != null"
                v-bind:class="active === '/settings' ? 'active-avatar':'border-avatar'"
                :src="avatar"
                :size="40"
              ></Avatar>
              <Avatar
                v-else
                v-bind:class="active === '/settings' ? 'active-avatar':'border-avatar'"
                :username="username"
                :size="40"
              ></Avatar>
            </v-btn>
          </template>
          <v-list class="my-vlist" dense>
            <v-list-item @click="routerMethod('messages')" class="my-vlistitem">
              <v-list-item-title class="my-vlistitemtitle">Messages</v-list-item-title>
            </v-list-item>
            <v-list-item @click="routerMethod('settings')" class="my-vlistitem">
              <v-list-item-title class="my-vlistitemtitle">Settings</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout" class="my-vlistitem">
              <v-list-item-title class="my-vlistitemtitle">Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-col>

    <v-menu v-if="$vuetify.breakpoint.smAndDown" left bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon size="30px" color="#B6C1CB">menu</v-icon>
        </v-btn>
      </template>

      <v-list class="my-vlist" dense>
        <v-list-item @click="gotoapp()" class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle">Go To App</v-list-item-title>
        </v-list-item>
        <v-list-item class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle">Features</v-list-item-title>
        </v-list-item>
        <v-list-item class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle">About Us</v-list-item-title>
        </v-list-item>
        <v-list-item class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle">Contact</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!loggedIn" @click="routerMethod('/login')" class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle">Login</v-list-item-title>
        </v-list-item>
        <v-divider class="mt-1 mb-2" v-if="loggedIn" light></v-divider>
        <v-list-item v-if="loggedIn" @click="routerMethod('settings')" class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle">Settings</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="loggedIn" @click="logout" class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle">Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-row>
</template>

<script>
import Avatar from "vue-avatar";
export default {
  components: {
    Avatar
  },
  data() {
    return {
      scrollPos: 0,
      loginDialog: false,
      signed: false,
      myProfile: [
        { title: "My Info" },
        { title: "My Strategy" },
        { title: "Stats" },
        { title: "Followers" },
        { title: "Blog" },
        { title: "Video" }
      ],
      myAccount: [
        { title: "Settings" },
        { title: "Billing Info" },
        { title: "Withdrawals" },
        { title: "Log Out" }
      ]
      //avatar: null
    };
  },
  computed: {
    avatar() {
      if (this.$store.getters.avatar == null) return null;
      else
        return `https://tradeinpool.com/upload/${this.$store.getters.avatar}.png`;
    },
    username() {
      return this.$store.getters.username;
    },
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    active() {
      return this.$route.path;
    }
  },
  created() {
    //this.avatar = `http://tradeinpool.com/upload/${this.$store.getters.avatar}.png`
  },

  mounted() {
    var vm = this;
    window.addEventListener("scroll", function() {
      vm.scrollPos = window.scrollY;
    });
  },
  methods: {
    routerMethod(path) {
      //this.active = path
      return this.$router.push(path);
    },
    gotoapp() {
      if (this.loggedIn) return this.$router.push("/pool");
      else return this.$router.push("/login");
    },
    logout() {
      this.$router.push({
        name: "Logout"
      });
    }
  }
};
</script>

<style scoped>
.my-vbtn {
  font-family: "Roboto", "Roboto Condensed Bold", sans-serif;
  color: #b6c1cb !important;
  text-transform: capitalize !important;
  font-size: 14px !important;
  max-height: 30px !important;
  padding-right: 10px !important;
  padding-left: 10px !important;
}
.my-vbtn:focus {
  outline: none !important;
}
.my-vbtn:hover {
  color: white !important;
}
.my-vlist {
  background-color: #b6c1cb !important;
}
.my-vlistitem {
  cursor: pointer !important;
  max-height: 20px !important;
  height: 20px !important;
}
.my-vlistitemtitle {
  font-size: 14px !important;
  color: #28303d !important;
  max-height: 20px !important;
}
.my-vlistitem:hover > .my-vlistitemtitle {
  color: white !important;
}
.my-vtoolbar {
  background-color: #1e242e !important;
  color: #ffffff !important;
}
.brand {
  margin-left: 20px;
  cursor: pointer;
}
.brand-name {
  font-size: 20px;
  font-weight: 100;
  margin-top: -10px;
}
.brand-img {
  margin-left: 40px;
  height: 50px;
  min-height: 50px;
}

.menu-main {
  padding-top: 15px;
  height: 50px;
  min-height: 50px;
}

.active {
  color: #4dbac0;
  font-weight: bolder;
}

.active {
  color: #4dbac0;
  font-weight: bolder;
}
.active-avatar {
  border: 2px solid #4dbac0;
  position: relative;
  top: -4px;
}
.border-avatar {
  border-style: outset;
  border: 2px solid #333b47;
  position: relative;
  top: -4px;
}
</style>